@file:OptIn(DelicateApi::class)

package club.srams.website.pages

import androidx.compose.runtime.Composable
import club.srams.website.components.layouts.PageLayoutData
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.dom.Iframe

@InitRoute
fun initEventCalendarPage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Event Calendar"))
}

@Page("event-calendar")
@Layout(".components.layouts.PageLayout")
@Composable fun EventCalendarPage() {



    EventCalendar(rememberBreakpoint())
}

@Composable
fun EventCalendar(
    breakpoint: Breakpoint
) {

    Box(Modifier.fillMaxSize()) {
        Iframe(
            attrs = {
                attr(
                    "src"
                    , "https://calendar.google.com/calendar/embed?src=sheltonrockandmineralsociety%40gmail.com&ctz=America%2FLos_Angeles")
// <iframe src="https://calendar.google.com/calendar/embed?height=600&wkst=1&ctz=America%2FLos_Angeles&showCalendars=0&src=c2hlbHRvbnJvY2thbmRtaW5lcmFsc29jaWV0eUBnbWFpbC5jb20&src=ZW4udXNhI2hvbGlkYXlAZ3JvdXAudi5jYWxlbmRhci5nb29nbGUuY29t&color=%23039be5&color=%230b8043" style="border-width:0" width="800" height="600" frameborder="0" scrolling="no"></iframe>
                attr(
                    "width"
                    , if (breakpoint <= Breakpoint.SM) {
                        "400"
                    } else {
                        "800"
                    }
                )
                attr(
                    "height"
                    , "600"
                )
                attr(
                    "frameborder"
                    , "0"
                ) // Optional
                attr(
                    "scrolling"
                    , "no"
                )
                attr(
                    "style"
                    , "border: 0"
                )
            }
        )
    }
}